import React, { useEffect, useState } from "react";
import { GridColDef } from '@mui/x-data-grid';
import GenericTable from "../GenericTable/GenericTable";
import { AvaliacaoObjTable, AvaliacaoTable } from "../../store/ducks/avaliacao/types";

const perf: AvaliacaoObjTable[] = [];
const col: GridColDef[] = [];

const AvaliacaoTableComponent = (props: any) => {

    const [txtBusca, setTxtBusca] = useState('');
    const [columns, setColumns] = useState(col);
    const [listAvaliacao, setListAvaliacao] = useState(perf);
    const [size, setSize] = useState(10);
    const [page, setPage] = useState(0);
    const [totalElements, setTotalElements] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [numberElements, setNumberElements] = useState(0);
    const [offset, setOffset] = useState(0);

    useEffect(() => {
        generateColumnsTable();
    }, []);

    useEffect(() => {
        if(props.data){
            tranformObjectTable(props.data)
        }
    }, [props.data]);

    const generateColumnsTable = () => {
        const _columns: GridColDef[] = [
            { field: 'nmAvaliacao', headerName: 'Nome', width: 300 },
            { field: 'dsAvaliacao', headerName: 'Descrição', width: 400 },
            { field: 'nmAvaliacaoTipo', headerName: 'Tipo Avaliacao', width: 300 },
            { field: 'idAvaliacao', headerName: 'ID da Avaliacao', width: 300 },
        ];

        setColumns(_columns);
    };

    const tranformObjectTable = (obj: AvaliacaoTable) => {
        setSize(obj.size);
        setPage(obj.number);
        setTotalElements(obj.totalElements);
        setTotalPages(obj.totalPages);
        setNumberElements(obj.numberOfElements);
        setOffset(obj.pageable.offset)

        let list: AvaliacaoObjTable[] = obj.content.map((item: any) => {
            return {
                id: item[0],
                nmAvaliacao: item[1],
                dsAvaliacao: item[2],
                nmAvaliacaoTipo: item[3],
                idAvaliacao: item[0]
            }
        });

        setListAvaliacao(list);
    };
    
    const onPageChange = (pageIdx: any) => {
        props.body.pagina = pageIdx - 1;
        setPage(pageIdx - 1)
        props.onChange(props.body);
    }

    const onSizeChange = (_size: any) => {
        props.body.tamanho = _size;
        setSize(_size);
        props.onChange(props.body);
    }

    const onChangeBusca = (txt: string) => {
        props.body.txtBusca = txt;
        setTxtBusca(txt);
        if(txt.length >= 3){
            props.onChange(props.body);
        } else {
            props.body.txtBusca = '';
            props.onChange(props.body);
        }
    }

    const onSortChange = (sort: any) => {
        if(sort != undefined) {
            let colunaSort = sort.field && 
            sort.field == "nmAvaliacao" ? 'nmAvaliacao' 
            : sort.field == "dsAvaliacao" ? 'dsAvaliacao'
            : sort.field == "nmAvaliacaoTipo" ? 'avaTipo.nmAvaliacaoTipo'
            : sort.field == "idAvaliacao" ? "idAvaliacao" : 'nmAvaliacao' ;

            props.body.coluna = colunaSort;
            props.body.ordem = sort.sort.toUpperCase();
        } else {
            props.body.coluna = 'nmAvaliacao';
            props.body.ordem = 'ASC';
        }
        props.onChange(props.body);

    }

    return (
        <GenericTable 
            loading={props.loading}
            titleTable='Avaliações Cadastrados'
            rows={listAvaliacao} 
            columns={columns} 
            page={page} 
            totalPages={totalPages} 
            onPageChange={onPageChange}
            offset={offset}
            numberElements={numberElements} 
            totalElements={totalElements}
            size={size}
            sizeChange={onSizeChange}
            txtBusca={txtBusca}
            onChangePesquisa={onChangeBusca}
            selection={props.selection}
            idSelectionChange={(arr: any) => props.idSelectionChange(arr)}
            sortChange={onSortChange}
        />
    )
};

export default AvaliacaoTableComponent;